import { Resolution } from '../utilities/types';

export const KEY = 'FRAMING_AND_WORKING_RESOLUTION_CALCULATORS';
export const LABEL = 'Framing and Working Resolution Calculators';

export const ANALYTICS_EVENTS = {
  EFFECTIVE_CANVAS_USED: 'effectiveCanvasUsed',
  CUSTOM_FRAMING_DECISION_USED: 'customFramingDecisionUsed',
  FRAMING_DECISION_RENAMED: 'framingDecisionRenamed',
  DOWNLOAD_PNG: 'downloadPng',
  DOWNLOAD_TIFF: 'downloadTiff',
  DOWNLOAD_FDL: 'downloadFdl',
} as const;

/**
 * Netflix logo dimensions from the actual asset file
 * These are used for aspect ratio calculations without needing to load the image
 */
export const NETFLIX_LOGO_DIMENSIONS: Resolution = {
  width: 1800,
  height: 756,
};

/**
 * Netflix logo asset path
 */
export const NETFLIX_LOGO_PATH = '/Netflix_Logo_RGB.png';
